/** Styl bublinkové nápovědy k tématu Erma */
export const TooltipStyles = {
  background: 'var(--erma-secondary-700)',
  color: 'var(--erma-primary-0)',
  borderRadius: 'var(--erma-border-radius-sm)',
  gutter: '.3rem',
  padding: '.429rem .857rem',
  maxWidth: '30rem'
};
